import {
	IVIPCertificatePipelineTest,
	IVIPCertificatePipelineTestSealing,
	createCertificatePipelineTest,
	createCertificatePipelineTestSealing,
	checkCertificatePipelineTest,
	checkCertificatePipelineTestSealing,
} from "@/loader";


export interface IVIPCertificatePipelineTests {
	disinfection: IVIPCertificatePipelineTest;
	backflow: IVIPCertificatePipelineTestSealing;
	sanitation: IVIPCertificatePipelineTestSealing;
	video: IVIPCertificatePipelineTest;
	compaction: IVIPCertificatePipelineTest;
	bending: IVIPCertificatePipelineTest;
}

export function createCertificatePipelineTests(): IVIPCertificatePipelineTests {
	return {
		disinfection: createCertificatePipelineTest(),
		backflow: createCertificatePipelineTestSealing(),
		sanitation: createCertificatePipelineTestSealing(),
		video: createCertificatePipelineTest(),
		compaction: createCertificatePipelineTest(),
		bending: createCertificatePipelineTest(),
	};
}

export function checkCertificatePipelineTests(data: IVIPCertificatePipelineTests) {
	if (data.disinfection === undefined) {
		data.disinfection = createCertificatePipelineTest();
	} else {
		checkCertificatePipelineTest(data.disinfection);
	}
	if (data.backflow === undefined) {
		data.backflow = createCertificatePipelineTestSealing();
	} else {
		checkCertificatePipelineTestSealing(data.backflow);
	}
	if (data.sanitation === undefined) {
		data.sanitation = createCertificatePipelineTestSealing();
	} else {
		checkCertificatePipelineTestSealing(data.sanitation);
	}
	if (data.video === undefined) {
		data.video = createCertificatePipelineTest();
	} else {
		checkCertificatePipelineTest(data.video);
	}
	if (data.compaction === undefined) {
		data.compaction = createCertificatePipelineTest();
	} else {
		checkCertificatePipelineTest(data.compaction);
	}
	if (data.bending === undefined) {
		data.bending = createCertificatePipelineTest();
	} else {
		checkCertificatePipelineTest(data.bending);
	}
}
